// This file is auto-generated by scripts/generate-version.js
// Do not edit manually

export const VERSION = {
  full: '1.1.0',
  major: '1',
  minor: '1',
  patch: '0',
  hash: '265e8d0',
  buildDate: '2026-03-10T01:01:34.338Z',
};
